module.exports = "<p class=\"adc-consent-error-message\">\n    {{ $t('lc_api_error') }}\n</p>\n"